import { path } from "../../settings";
import { NavContainer, StyledNavLink } from "./styled";

const Navigation = () => {
    return (
        <NavContainer>
            <StyledNavLink to={path.home}>Home</StyledNavLink>
            <StyledNavLink to={path.prices}>Price list</StyledNavLink>
            <StyledNavLink to={path.more}>More</StyledNavLink>
        </NavContainer>
    )
};

export default Navigation;